import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { authentication } from '@perpay-web/authentication/singleton';
import {
    analyticsSSICardApplicationClickSplitContinue,
    analyticsSSICardApplicationViewSplitPage,
} from '@perpay-web/fintech/actions/analytics/SSIcardApplication';
import {
    createDeduction,
    clearDeductionError,
} from '@perpay-web/fintech/actions/entities/deductions';
import SSICardApplicationDirectDepositSummary from '@perpay-web/fintech/components/composite/CardApplicationDirectDepositSummary/SSICardApplicationDirectDepositSummary';
import { PINWHEEL_STEP } from '@perpay-web/fintech/components/screens/CardApplication/CardApplicationSteps';
import { useCardApplicationContext } from '@perpay-web/fintech/components/screens/CardApplication/useCardApplicationContext';
import {
    generalAccountSummaryDataModule,
    getMinimumPayment,
} from '@perpay-web/fintech/dataModules/generalAccountSummary';

const SSICardApplicationDirectDepositSummaryContainer = () => {
    const partnerCode = authentication.getPartnerOnboardedCode();
    const dispatch = useDispatch();
    const { setStep } = useCardApplicationContext();
    const totalMinimumPayment = useSelector(getMinimumPayment);

    const onMount = useCallback(() => {
        dispatch(generalAccountSummaryDataModule.dataRequest());
        dispatch(analyticsSSICardApplicationViewSplitPage());
    }, [dispatch]);

    const onUnmount = useCallback(() => {
        dispatch(generalAccountSummaryDataModule.dataReset());
        dispatch(clearDeductionError());
    }, [dispatch]);

    return (
        <SSICardApplicationDirectDepositSummary
            partnerCode={partnerCode}
            onMount={onMount}
            onUnmount={onUnmount}
            totalMinimumPayment={totalMinimumPayment}
            onClickContinue={() => {
                setStep(PINWHEEL_STEP);
                dispatch(analyticsSSICardApplicationClickSplitContinue());
                dispatch(
                    createDeduction({
                        amount: totalMinimumPayment,
                        isPerpaySplit: true,
                    }),
                );
            }}
        />
    );
};

export default SSICardApplicationDirectDepositSummaryContainer;
